import { render } from "./CustomerForm.vue?vue&type=template&id=5b000082&scoped=true&ts=true"
import script from "./CustomerForm.vue?vue&type=script&lang=ts"
export * from "./CustomerForm.vue?vue&type=script&lang=ts"

import "./CustomerForm.vue?vue&type=style&index=0&id=5b000082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b000082"]])

export default __exports__